<template>
  <div class="flex flex-row items-center">

    <!-- Selector de color in-app (Buefy): se despliega y cierra dentro de la app,
         sin el diálogo del sistema operativo que abría el input nativo. Mantenemos
         colorSelected como string hex (lo usan también los presets y la validación). -->
    <b-colorpicker
      :value="colorSelected"
      @input="onColorPick"
      :alpha="false"
      :color-formatter="formatter"
      size="is-small"
    />

    <!-- Paleta de colores rápidos -->
    <div class="flex flex-row items-center ml-3 mr-1">
      <span v-for="preset in presetColors" :key="preset"
        class="epc-color-dot"
        :class="{ 'is-selected': colorSelected.toLowerCase() === preset }"
        :style="{ backgroundColor: preset }"
        @click="colorSelected = preset"></span>
    </div>

    <div class="flex-grow mx-2">
      <b-input
        v-model="nameLegendTemp"
        :placeholder="$t('legend_name')"
        expanded
        @keyup.enter.native="addLegend()"
      ></b-input>
    </div>

    <b-button type="is-primary" icon-pack="fas" icon-left="plus" @click="addLegend()">
      {{ $t('add_legend') }}
    </b-button>
  </div>
</template>

<script>

export default {
  name: "legend-document-form",

  props: {

  },

  data() {
    return {
      colorSelected: '#7957d5',
      nameLegendTemp: '',
      presetColors: [
        '#22c55e', // verde
        '#eab308', // amarillo
        '#f97316', // naranja
        '#ef4444', // rojo
        '#3b82f6', // azul
        '#7957d5', // morado
        '#14b8a6', // turquesa
        '#64748b', // gris
      ],
    };
  },

  methods: {
    addLegend() {
      if (!this.nameLegendTemp) {
          this.$notify.error('legend_name_empty');
          return;
        }

        if (!this.isValidHex(this.colorSelected)) {
          this.$notify.error('invalid_color');
          return;
        }

        this.$emit('epc-add-legend', {
          name: this.nameLegendTemp,
          color: this.colorSelected
        });

        this.nameLegendTemp = '';
    },

    isValidHex(color) {
      return /^#[0-9A-Fa-f]{6}$/i.test(color);
    },

    // b-colorpicker emite un objeto Color; lo pasamos a hex string para
    // mantener colorSelected como string (coherente con los presets).
    onColorPick(color) {
      this.colorSelected = this.formatter(color);
    },

    formatter(color) {
      return typeof color === 'string' ? color : color.toString('hex');
    },
  }
}
</script>

<style scoped>
.epc-color-dot {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 9999px;
  display: inline-block;
  margin-right: 0.35rem;
  cursor: pointer;
  border: 2px solid transparent;
  transition: transform 0.1s ease;
  flex-shrink: 0;
}
.epc-color-dot:hover {
  transform: scale(1.2);
}
.epc-color-dot.is-selected {
  border-color: #363636;
  transform: scale(1.15);
}
</style>
